(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-price', {
            parent: 'entity',
            url: '/invoice-price?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.invoicePrice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-price/invoice-prices.html',
                    controller: 'InvoicePriceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoicePrice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-price-detail', {
            parent: 'invoice-price',
            url: '/invoice-price/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.invoicePrice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-price/invoice-price-detail.html',
                    controller: 'InvoicePriceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoicePrice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InvoicePrice', function($stateParams, InvoicePrice) {
                    return InvoicePrice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice-price',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-price-detail.edit', {
            parent: 'invoice-price-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-price/invoice-price-dialog.html',
                    controller: 'InvoicePriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePrice', function(InvoicePrice) {
                            return InvoicePrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-price.new', {
            parent: 'invoice-price',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-price/invoice-price-dialog.html',
                    controller: 'InvoicePriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                price: null,
                                weightInKgs: null,
                                weightInLbs: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice-price', null, { reload: 'invoice-price' });
                }, function() {
                    $state.go('invoice-price');
                });
            }]
        })
        .state('invoice-price.edit', {
            parent: 'invoice-price',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-price/invoice-price-dialog.html',
                    controller: 'InvoicePriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePrice', function(InvoicePrice) {
                            return InvoicePrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-price', null, { reload: 'invoice-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-price.delete', {
            parent: 'invoice-price',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-price/invoice-price-delete-dialog.html',
                    controller: 'InvoicePriceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InvoicePrice', function(InvoicePrice) {
                            return InvoicePrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-price', null, { reload: 'invoice-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
